import { render, staticRenderFns } from "./store-item-external-dialog.vue?vue&type=template&id=596197c6&scoped=true"
import script from "./store-item-external-dialog.vue?vue&type=script&lang=js"
export * from "./store-item-external-dialog.vue?vue&type=script&lang=js"
import style0 from "./store-item-external-dialog.vue?vue&type=style&index=0&id=596197c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596197c6",
  null
  
)

export default component.exports